import { config } from "../constants";

const DEFAULT_PRIMARY_COLOR = "#16A34A";
const DEFAULT_SIDEBAR_COLOR = "#064E3B";
const DEFAULT_HEADER_COLOR = "#FFFFFF";

export function applyTenantBranding(tenant) {
  const primaryColor =
    tenant?.primary_color ??
    tenant?.settings?.theme?.primaryColor ??
    DEFAULT_PRIMARY_COLOR;
  const sidebarColor =
    tenant?.settings?.theme?.sidebarColor ?? DEFAULT_SIDEBAR_COLOR;
  const headerColor =
    tenant?.settings?.theme?.headerColor ?? DEFAULT_HEADER_COLOR;

  document.documentElement.style.setProperty("--tenant-primary", primaryColor);
  document.documentElement.style.setProperty("--primary-color", primaryColor);
  document.documentElement.style.setProperty("--sidebar-color", sidebarColor);
  document.documentElement.style.setProperty("--header-color", headerColor);
}

export function resolveTenantAssetUrl(path, storageUrl) {
  if (!path) {
    return null;
  }
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  if (path.startsWith("/")) {
    return `${storageUrl}${path}`;
  }
  return `${storageUrl}/${path}`;
}

export function tenantLogoUrl(tenant) {
  return resolveTenantAssetUrl(tenant?.logo_url, config.url.STORAGE_URL);
}

/**
 * @param {{ name?: string } | null} tenant
 * @param {string | null} [pageTitle]
 */
export function tenantAppTitle(tenant, pageTitle = null) {
  return [pageTitle, tenant?.name, "QA Trace"]
    .filter(Boolean)
    .filter(
      (part, index, parts) =>
        parts.findIndex(
          (candidate) => candidate.toLowerCase() === part.toLowerCase(),
        ) === index,
    )
    .join(" · ");
}
